import { render } from "./Diner.vue?vue&type=template&id=0e65b954&scoped=true"
import script from "./Diner.vue?vue&type=script&lang=js"
export * from "./Diner.vue?vue&type=script&lang=js"

import "./Diner.vue?vue&type=style&index=0&id=0e65b954&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e65b954"]])

export default __exports__